    // ajax setup for POST method
    const csrftoken = jQuery("[name=csrfmiddlewaretoken]").val();
    const csrfSafeMethod = (method) => {
        // these HTTP methods do not require CSRF protection
        return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
    }
    $.ajaxSetup({
      beforeSend: function(xhr, settings) {
        if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
          xhr.setRequestHeader("X-CSRFToken", csrftoken);
        }
      },
    });

    // define user is authenticated
    const checkUser = () => {
      const is_authenticated = document.getElementById('main_container').getAttribute('data-is_auth')
      if ( is_authenticated == 'True' ) {
        return true
      }
      return false
    }

    // define check number
    const checkNumber = (value) => {
      return Number.isInteger(Number(value))
    }

    // define 숫자에 콤마 추가
    const addComma = (value) => {
      return Number(value).toLocaleString('en');
    }

    // define 금액 변경
    const changePrice = (quantity_line) => {
      const quantity = quantity_line.val()
      if ( checkNumber(quantity) ) {
        const price = quantity_line.data('price')
        let total_price = Number(quantity) * Number(price);
        total_price = addComma(total_price)
        quantity_line.parent().next().find('span').html(total_price)
      }
    }

    // define get form data (장바구니, 구매 폼 전송용)
		const get_form_data = (obj) => {
			const quantity = obj.parent().parent().find('input').val()
			const merchandise = obj.parent().parent().find('input').data('option_id')
			$('#id_cart_form input[name=quantity]').val(quantity)
			$('#id_cart_form input[name=merchandise]').val(merchandise)
			const data = $('#id_cart_form').serialize();
			return data
		}


		// 수량 변경 시 금액 변경
    $('input[name=quantity]').change(function (){
      changePrice($(this))
    })


		// 장바구니 버튼 클릭
    $('.add_cart').click(function (){
      if ( checkUser() ) {
        // call ajax
        const quantity = $(this).parent().parent().find('input').val()
        if ( checkNumber(quantity) ) {
          const data = get_form_data($(this))
          // const url = "{% url 'cart-add' %}"
          const url = document.getElementById('main_container').getAttribute('data-cart_url')
          $.ajax({
            type: "POST",
            url: url,
            data: data,
            success: function(data) {
              if ( data['is_success'] == true ) {
                $('#id_cart_success_modal').click()
              }
              else {
                const error_message = data['error_message']
                $('#error_message').html(error_message)
                $('#id_cart_error_modal').click()
              }
            }
          })
        }
        else {
          alert('올바른 수량을 선택하여주세요.')
        }
      }
      else {
        // open modal (login required)
        $('#id_login_modal').click()
      }
    })


		// 구매 버튼 클릭
    $('.act_purchase').click(function (){
      if ( checkUser() ) {
        // form submit (POST)
        const tr = $(this).parent().parent();
        const quantity = tr.find('input[name="quantity"]').val();
        const option_id = tr.find('input[name=quantity]').data('option_id')
        var form = $('#id_cart_form');
        form.find('input[name="merchandise"]').val(option_id);
        form.find('input[name="quantity"]').val(quantity);
        form.submit();
      }
      else {
        // open modal (login required)
        $('#id_login_modal').click()
      }
    })
